import {
    HomePageContainer as SourceHomePageContainer,
    mapStateToProps
} from 'SourceRoute/HomePage/HomePage.container';
import { connect } from 'react-redux';

import CmsPage from 'Route/CmsPage';
import BlogFeed from 'Component/BlogFeed';
import InstallPrompt from 'Component/InstallPrompt';

import { showNotification } from 'Store/Notification/Notification.action';
import { changeNavigationState } from 'Store/Navigation/Navigation.action';
import { TOP_NAVIGATION_TYPE } from 'Store/Navigation/Navigation.reducer';

import { DEFAULT_STATE_NAME } from 'Component/NavigationAbstract/NavigationAbstract.config';

export const mapDispatchToProps = (dispatch) => ({
    changeHeaderState: (state) => dispatch(changeNavigationState(TOP_NAVIGATION_TYPE, state)),
    showNotification: (type, message) => dispatch(showNotification(type, message))
});

export class HomePageContainer extends SourceHomePageContainer {
    componentDidMount() {
        const { changeHeaderState, showNotification } = this.props;

        changeHeaderState({
            name: DEFAULT_STATE_NAME,
            isHiddenOnMobile: true
        });

        const unsubscribe = new URLSearchParams(location.search).get('unsubscribe');
        const unsubscribeError = new URLSearchParams(location.search).get('unsubscribe-error');

        if (unsubscribe || unsubscribeError) {
            showNotification(unsubscribe ? 'success' : 'error', unsubscribe || unsubscribeError);
        }

        const unsubscribeMessage = new URLSearchParams(location.search).get('message');
        if (unsubscribeMessage) {
            showNotification('success', unsubscribeMessage);
        }
    }

    render() {
        return (
            <div block="HomePage">
                <InstallPrompt />
                <CmsPage { ...this.props } isBreadcrumbsActive={ false } />
                <BlogFeed />
            </div>
        )
    }

};

export default connect(mapStateToProps, mapDispatchToProps)(HomePageContainer);
